export default "__VITE_ASSET__fbf81448__"